export default __webpack_public_path__ + "static/media/logo-navy-with-tagline.0657669e.png";